import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('pantebokOrder', {
  nb: {
    orderCertifiedCopy: 'Bestill bekreftet kopi',
    productFee: 'gebyr',
    currencyShortNOK: 'kr',
    productNotAvailable: 'Ikke tilgjengelig',
    purchaseFailed: 'Bestilling feilet. Du har ikke blitt trukket',
    purchaseInProgress: 'Bestiller..',
    ordered: 'Bestilt'
  },
  'en-us': {
    orderCertifiedCopy: 'Order certified copy',
    productFee: 'fee',
    currencyShortNOK: 'kr',
    productNotAvailable: 'Not available',
    purchaseFailed: 'Purchase failed. You have not been billed',
    purchaseInProgress: 'Ordering..',
    ordered: 'Ordered'
  }
});
